import { Dispatch } from "redux";
import { CourseTagsData } from "../../models/courseData";
import { courseTagsService } from "../../api/index";

import {
  COURSE_TAGS_REQUEST,
  COURSE_TAGS_SUCCESS,
  COURSE_TAGS_FAILURE,
  CourseTagsActionTypes,
  CourseTagsRequestAction,
  CourseTagsFailureAction,
  CourseTagsSuccessAction,
} from "./types";

/**
 * Async action to fetch course tags.
 *
 * Dispatches a request action, then attempts to fetch course tags from the API.
 * If successful, dispatches success action with data.
 * If failed, dispatches failure action.
 *
 * @returns A thunk action for Redux.
 */
export const getCourseTags = () => {
  return async (dispatch: Dispatch<CourseTagsActionTypes>) => {
    dispatch(courseTagsRequest());
    courseTagsService
      .getCourseTags()
      .then((response: CourseTagsData[]) => {
        dispatch(courseTagsSuccess(response));
      })
      .catch(() => {
        dispatch(courseTagsFailure());
      });
  };
};

/**
 * Action creator for successfully fetched course tags.
 *
 * @param data - Array of course tags objects.
 * @returns Action with type `COURSE_TAGS_SUCCESS` and payload.
 */
export function courseTagsSuccess(data: CourseTagsData[]): CourseTagsSuccessAction {
  return {
    type: COURSE_TAGS_SUCCESS,
    data,
  };
}

/**
 * Action creator for initiating the course tags request.
 *
 * @returns Action with type `COURSE_TAGS_REQUEST`.
 */
export function courseTagsRequest(): CourseTagsRequestAction {
  return {
    type: COURSE_TAGS_REQUEST,
  };
}

/**
 * Action creator for failed course tags request.
 *
 * @returns Action with type `COURSE_TAGS_FAILURE`.
 */
export function courseTagsFailure(): CourseTagsFailureAction {
  return {
    type: COURSE_TAGS_FAILURE,
  };
}
